export const state = () => ({
	popUpLoading: false
});

export const mutations = {
	setLoading(state, { name, value }) {
		state[name] = value;
	}
};
